import 'normalize.css';
import './main.css';
import { Navigator } from 'three';

const IS_IOS =
  /^(iPad|iPhone|iPod)/.test(window.navigator.platform) ||
  (/^Mac/.test(window.navigator.platform) && window.navigator.maxTouchPoints > 1);

function getMobileOperatingSystem() {
  if (IS_IOS) return 'ios';

  // @ts-ignore
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  if (
    /android/i.test(userAgent) &&
    !/windows phone/i.test(userAgent) &&
    window.navigator.maxTouchPoints > 1
  ) {
    return 'android';
  }

  return '';
}

async function checkArSupport(): Promise<'arkit' | 'webxr' | 'none'> {
  if (IS_IOS) {
    // https://stackoverflow.com/questions/46717533/detecting-arkit-compatible-device-from-user-agent
    if (document.createElement('a').relList.supports('ar')) {
      return 'arkit';
    } else {
      return 'none';
    }
  } else {
    const { xr } = navigator as Navigator;
    if (!xr) return 'none';
    try {
      const isWebXRSupported = await xr.isSessionSupported('immersive-ar').catch(() => {
        return 'none';
      });
      return isWebXRSupported ? 'webxr' : 'none';
    } catch (e) {
      return 'none';
    }
  }
}

function checkWebview(): boolean {
  let isWebView = navigator.userAgent.includes('wv');
  if (!isWebView && IS_IOS) {
    // @ts-ignore
    var standalone = window.navigator.standalone;
    let userAgent = window.navigator.userAgent.toLowerCase();
    let safari = /safari/.test(userAgent);
    if (!standalone && !safari) {
      isWebView = true;
    }
  }
  return isWebView;
}

function configureBGVideo() {
  const bgVideo = document.querySelector('.bg-video video') as HTMLVideoElement | null;
  if (bgVideo) {
    // Replay video when returning to lander from AR
    bgVideo.onpause = () => {
      bgVideo.play();
    };
  }
}

async function init() {
  const mobileOS = getMobileOperatingSystem();
  const isInApp = checkWebview();
  let [arSupport] = await Promise.all([checkArSupport()]);
  const isSamsungBrowser = navigator.userAgent.match(/SamsungBrowser/i);
  if (isInApp || isSamsungBrowser) {
    arSupport = 'none';
  }

  document.documentElement.classList.add(
    isInApp ? 'is-in-app' : mobileOS ? `is-mobile-os` : 'is-unknown-os',
    arSupport === 'arkit' ? 'has-arkit' : arSupport === 'webxr' ? 'has-webxr' : 'no-ar',
    arSupport === 'none' ? 'unsupported-device' : 'supported-device',
    'ready'
  );

  configureBGVideo();
}

init();
